export interface ComponentLocation {
    app: string;
    subApp: string;
    section: string;
}

export const emptyComponentLocation: ComponentLocation = { app: '', subApp: '', section: '' };
